import queryString from 'query-string';

export const urlInterpolate = (urlTemplate, query, params) => {
  const interpolatedUrl = urlTemplate.replace(
    /:([\w\d-]+)/g,
    (sustr, match) => params[match] || '',
  );

  if (Object.keys(query).length > 0) {
    return `${interpolatedUrl}?${queryString.stringify(query)}`;
  }
  return interpolatedUrl;
};
